import type { FullStackPack } from "~/models/dto";
import type { RequestStatus } from "~/tools/request-status";

export interface StackPacksState {
	stackPacksStatus: RequestStatus<Error, Array<FullStackPack>> | undefined;
}

export const initialStackPacksState: StackPacksState = {
	stackPacksStatus: undefined,
};
